import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Avatar from '@deprecated-ui/common/Avatar';
import color from '@deprecated-ui/_style/color';
import { LabelVerifiedAccount } from 'global/Labels';
import Image from 'global/Image';
import { AVATAR_URL } from 'constants/api';
import TextContent from 'global/StreamWidget/TextContent';
import { RepostBoxContainer } from 'global/StreamWidget/Post/styled';
import ImageSlider from 'global/ImageSlider';
import { handleErrorAvatar } from 'utils/general';
import { StreamPostData } from '../../../@types/stream';

interface RepostBoxProps {
  post: StreamPostData;
}

function RepostBox({ post }: RepostBoxProps) {
  const postData = post.repostedfrom ? post.repostedfrom : post;
  const {
    content_original: content,
    title,
    newsfeed_source: newsSource,
    newsfeed_label: newsLabel,
    newsfeed_img: newsImg,
    avatar,
    username,
    official,
    mask_html,
    images_data: imagesData,
    image_frame_type: imageFrameType,
  } = postData;

  const avatarUrl = avatar?.startsWith('http')
    ? avatar
    : `${AVATAR_URL}/${avatar}`;
  let trimmedTextContent = content?.substring(0, 400) || '';
  trimmedTextContent = trimmedTextContent.substring(
    0,
    Math.min(trimmedTextContent.length, trimmedTextContent.lastIndexOf(' ')),
  );
  const isHaveImage = Boolean(imagesData?.length > 0 && imagesData[0]?.image);

  return (
    <div>
      <RepostBoxContainer>
        {/* @ts-expect-error */}
        <Flex align="center" mb="8px">
          {/* @ts-expect-error */}
          <Avatar size="x-small" mr="12px">
            <Image
              src={avatarUrl}
              alt={username}
              onError={(e) => handleErrorAvatar(e, username)}
            />
          </Avatar>
          <Text family="bold" size="16px">
            {username}
          </Text>
          <LabelVerifiedAccount
            deprecatedVerifiedStatus={official > 0}
            verifiedStatus={postData?.verified_status}
          />
        </Flex>
        {isHaveImage && (
          <ImageSlider
            images={imagesData}
            frameType={imageFrameType}
            clickable={false}
          />
        )}
        {title && (
          // @ts-expect-error
          <Text color={color.primary} mb="8px">
            {title}
          </Text>
        )}
        <Text height="22.475px">
          <TextContent
            content={content}
            maskedHtml={mask_html}
            isDefaultExpand
            isRepost
            style={{ marginBottom: 0 }}
          />
        </Text>
        {newsSource && (
          <Flex>
            <Image
              alt={newsLabel}
              src={newsImg}
              style={{ width: '16px', marginRight: '8px' }}
            />
            <Text size="12px">{newsLabel}</Text>
          </Flex>
        )}
      </RepostBoxContainer>
    </div>
  );
}

export default RepostBox;
